import * as types from './types';

const INITIAL_STATE = {
  templates: [],
  fetching: false,
  error: null,
  preview: null,
  previewFetching: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.LETTER_WRITE_CUSTOM_LETTER_FETCHING:
    case types.LETTER_TEMPLATES_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.LETTER_TEMPLATES_FETCH:
      return {
        ...state,
        templates: payload,
      };
    case types.LETTER_TEMPLATES_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.LETTER_PREVIEW_FETCHING:
      return {
        ...state,
        previewFetching: payload,
      };
    case types.LETTER_PREVIEW_FETCH:
      return {
        ...state,
        preview: payload,
      };
    case types.LETTER_PREVIEW_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.LETTER_PREVIEW_CLEAR:
      return {
        ...state,
        preview: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/lettersetup/state/setup/reducer.js